import type { DesignSystemComponentKey } from '../theme/scopeDesignSystem';

export const SWITCH_FIELD_DESIGN_SYSTEM_KEYS = [
  'MuiSwitch',
  'MuiFormControlLabel',
] as const satisfies readonly DesignSystemComponentKey[];
